import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { DhukanDataService } from 'src/app/services/dhukan/dhukan-data.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { LoginDataService } from 'src/app/services/dhukan/login-data.service';
@Component({
  selector: 'app-adduser',
  templateUrl: './adduser.component.html',
  styleUrls: ['./adduser.component.css']
})
export class AdduserComponent implements OnInit {

  emailPattern = "^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$";

  //Mode Values
  isaddmode: boolean = false;
  iseditmode: boolean = false;
  isdeletemode: boolean = false;
  isviewmode: boolean = false;

  //Save Validation
  submitted: boolean;
  successfully: boolean;
  saveloading: boolean;

  show: boolean;
  showsecurity: boolean;
  //Edit Get Values
  userColl: any = [];
  userbranchColl: any = [];
  userroleColl: any = [];
  userid: number = 0
  emailreadonly: boolean = false
  isenablesecuritykey: boolean = false

  //pageColl:any=[];

  userform = new FormGroup({
    userid: new FormControl(0),
    userroleid: new FormControl(null, Validators.required),
    username: new FormControl('', Validators.required),
    pwd: new FormControl('', Validators.required),
    emailid: new FormControl(''),
    securitykey: new FormControl(null, [Validators.required, Validators.minLength(5), Validators.maxLength(5)]),
    inactive: new FormControl(false),
  });

  isloading: boolean = false;
  isprivilage: boolean = false;
  showProgress: boolean = false;
  formname: String = "User";

  isrestaurant: boolean = false;


  constructor(private appService: DhukanDataService, private route: ActivatedRoute,
    public router: Router, private toastr: ToastrService, public loginService: LoginDataService) {
    this.route.queryParams.subscribe(params => {
      if (params.id !== undefined) {
        this.userid = params.id
      }
    });
    this.fnServiceChanges();
  }


  fnServiceChanges() {
    this.loginService.serviceloginChange.subscribe((value) => {
      if (this.loginService.fnCheckCompany()) {
        if (this.loginService.fnCheckUser()) {

          if (this.fnCheckUserPririvilage()) {
            this.isloading = true;
            this.fnOnInitForm();
          }
          else {
            this.fnUserFailedForm();
          }

        }
        else {
          this.fnUserFailedForm();
        }
      }
      else {
        this.loginService.fnCompanyFaildRedirect();
      }
    });
  }

  ngOnInit() {
    try {
      if (this.loginService.fnCheckCompany()) {
        if (this.loginService.fnCheckUser()) {
          if (this.fnCheckUserPririvilage()) {
            this.isloading = true;
            this.fnOnInitForm();
          }
          else {
            this.fnUserFailedForm();
          }
        }
        else {
          this.loginService.fnGetUserRoleList();
        }
      }
      else {
        this.loginService.fnCompanyFaildRedirect();
      }
    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }

  fnOnInitForm() {
    try {
      this.isaddmode = true;
      this.userform.reset();
      this.fnInitializeUser();

      if (this.userid > 0) {
        this.emailreadonly = true;
        this.fngetUser();
      }
      this.fngetUserrole();
      this.fngetUserBranch();

      if (this.loginService.fnGetCompanyId() > 0) {
        this.isrestaurant = true;
      }

    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }



  fnCheckUserPririvilage() {
    var _check: boolean = false;
    if (this.userid > 0) {
      _check = this.loginService.fnCheckUserRoleAction(this.formname, 'ALTER')
    } else {
      _check = this.loginService.fnCheckUserRoleAction(this.formname, 'CREATE')
    }

    return _check;
  }

  fnUserFailedForm() {
    this.isprivilage = true;
  }


  fnInitializeUser() {
    this.userform.setValue({

      userid: 0,
      username: '',
      pwd: '',
      emailid: '',
      securitykey: '',
      userroleid: null,
      inactive: false,
    })
  }

  fngetUserrole() {
    this.fnShowProgress();
    var data = {
      'userroleid': 0,
      'companyid': this.loginService.fnGetCompanyId(),
      'modifiedby': this.loginService.fnGetModUserId(),
      'organizationid': this.loginService.fnGetOrganizationId(),
    }
    this.appService.getUserrole(data)
      .subscribe(
        (res) => {
          this.fnHideProgress();
          if (res.json().status == 200) {
            this.userroleColl = res.json().result;

         
          }
          else if (res.json().status == 400) {
            this.toastr.error('Error', res.json().err_field);
          }


        },
        (err) => {
          this.fnHideProgress();
          this.toastr.error('Error', err);
        })
  }


  fngetUserBranch() {
    var data = {
      'userid': this.userid,
      'modifiedby': this.loginService.fnGetModUserId(),
    }
    this.appService.getUserBranch(data)
      .subscribe(
        (res) => {
          console.log(res.json().result)
          this.userbranchColl = res.json().result;

          if (this.loginService.fnGetCompanyId() > 0 && this.userbranchColl.length===1) {
            this.userbranchColl[0].ischeck=true
          }
          else if (this.loginService.fnGetCompanyId() > 0 && this.userbranchColl.length>1) {
            var index=0;
            for(let abo of this.userbranchColl){
              if(abo.companyid==this.loginService.fnGetCompanyId()){
                break
              }
              index=index+1
            }
            this.userbranchColl[index].ischeck=true
          }
        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }

  //Get 
  fngetUser() {
    var data = {
      'userid': this.userid,
      'companyid': this.loginService.fnGetCompanyId(),
      'organizationid': this.loginService.fnGetOrganizationId(),
    }
    this.appService.getUser(data)
      .subscribe(
        (res) => {
          this.userColl = res.json().result;
          var editdata = this.userColl[0];
          this.fnEditMode(editdata);
        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }



  //Save Btn Click
  fnSaveBtnClick() {
    try {

      if(this.fnCheckBranch()===false){
        this.toastr.error('Error', "Minimum One Branch Selected");
        return
      }


      if (this.saveloading) {
        return;
      }
      this.submitted = true;
      this.successfully = false;
      //Validate
      if (this.userform.valid) {
        this.saveloading = true;
        //Check
        var data = {
          'userid': this.userid,
          'username': this.userform.get('username').value,
          'emailid': this.userform.get('emailid').value,
          'pwd': this.userform.get('pwd').value,
          'securitykey': this.userform.get('securitykey').value,
          'userroleid': this.userform.get('userroleid').value,
          'inactive': this.userform.get('inactive').value,
          'companyid': this.loginService.fnGetCompanyId(),
          'organizationid': this.loginService.fnGetOrganizationId(),
          'createdby': this.loginService.fnGetModUserId(),
          'modifiedby': this.loginService.fnGetModUserId(),
          'userbranchColl': this.userbranchColl
        }
        this.appService.fnCheckUser(data).subscribe(
          (res) => {

            var _checkresult = res.json().result[0].checkfield;

            if (_checkresult === "done") {
              if (this.userform.get('userid').value > 0) {
                //Update Department
                this.fnSetUser(data);
              }
              else {
                //Insert Department
                this.fnInsertUser(data);
              }
            }
            else {
              if (_checkresult === "name") {
                this.saveloading = false;

                this.userform.controls['emailid'].setErrors({ 'notfound': true });
              } else if (_checkresult === "securitykey") {
                this.saveloading = false;

                this.userform.controls['securitykey'].setErrors({ 'notfound': true });
              }
            }
          },
          (err) => {
            this.saveloading = false;

            this.toastr.error('Error', err);
          });
      }
    } catch (ex) {
      this.saveloading = false;

      this.fnShowErrorMsg(ex);
    }
  }

  //Insert
  fnInsertUser(data) {

    this.appService.fnInsertUser(data).subscribe(
      (res) => {
        this.saveloading = false;

        if (res.json().result != "") {
          this.toastr.success('', "The new User has been added successfully.Insert Successfully");

          this.fnInsertActivityLog('INSERT', 0, data.username);

          this.fnCloseUser();
        }
      },
      (err) => {
        this.saveloading = false;

        this.toastr.error('Error', err);
      });

  }

  //Set
  fnSetUser(data) {

    this.appService.fnSetUser(data).subscribe(
      (res) => {
        this.saveloading = false;

        if (res.json().result != "") {
          this.toastr.success('', "The user has been updated successfully.");

          this.fnInsertActivityLog('EDIT', this.userid, data.username);

          this.fnCloseUser();
        }
      },
      (err) => {
        this.saveloading = false;

        this.toastr.error('Error', err);
      });

  }

  fnCheckBranch() {
    let check = false;
    for (let abo of this.userbranchColl) {
      if (abo.ischeck) {
        check = true;
      }
    }

    return check;
  }

  //Close
  fnCloseUser() {
    try {
      this.router.navigate(['/User']);
    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }

  private fnEditMode(deptBO) {

    this.userform.setValue({

      userid: deptBO.userid,
      username: deptBO.username,
      pwd: deptBO.pwd,
      securitykey: deptBO.securitykey,
      emailid: deptBO.emailid,
      userroleid: deptBO.userroleid,
      inactive: deptBO.inactive,
    });


    this.isaddmode = false;
    this.iseditmode = true;
    this.isdeletemode = false;
    this.isviewmode = false;
  }

  fnShowpassword() {

    this.show = !this.show;
  }
  fnShowSecurity() {

    this.showsecurity = !this.showsecurity;
  }

  checkValue(values: any, index) {
    this.userbranchColl[index].ischeck = values.currentTarget.checked;
  }

  fnInsertActivityLog(action, refno, desc) {
    try {
      var data = {
        logtype: action,
        logat: this.formname,
        refnum: refno,
        logdescr: desc,
        logby: this.loginService.fnGetModUserId(),
        'companyid': this.loginService.fnGetCompanyId(),
      }


      this.appService.fnInsertActivity(data).subscribe(
        (res) => {
        },
        (err) => {

        });

    } catch {

    }
  }



  private fnShowProgress() {
    this.showProgress = true;
  }
  private fnHideProgress() {
    this.showProgress = false;
  }

  private fnShowErrorMsg(ex) {
    this.toastr.warning('Internal Error', ex);
  }





}
